/* global $ */
import { viewportWidth } from '../helpers/dom-tools';

const $modules = $.$body.find('[data-module],.module');

// add class to last module
$modules.last().addClass('last-module');

let timeOutId = null;

// Accordions
$.$body
	.on('focus', '.module__accordion .js-accordion-button', (e) => {
		$(e.currentTarget).attr('aria-selected', true);
	})
	.on('blur', '.module__accordion .js-accordion-button', (e) => {
		$(e.currentTarget).attr('aria-selected', false);
	})
	.on('click', '.module__accordion .js-accordion-button', (e) => {
		e.preventDefault();

		// const scrollTime = 400;
		const $top = $.$body.find('#masthead');
		const navHeight = $top.innerHeight();

		const $button = $(e.currentTarget);
		const isExpanded = $button.attr('aria-expanded') === 'true';
		const $header = $button.closest('.accordion__container');
		const $section = $button.next('.accordion__content');
		// const $section = $header.next('.accordion__content');

		$button.attr('aria-expanded', !isExpanded);
		$section.attr('aria-hidden', isExpanded);

		if (!isExpanded) {
			if (viewportWidth() <= 991) {
				const $rowAnchor = $header.closest('.accordion__single-row');
				window.scrollTo(0, $rowAnchor.offset().top - navHeight);
			}
			clearTimeout(timeOutId);
			timeOutId = setTimeout(() => {
				$section.addClass('js-accordion-fully-open');
			}, 500);
		} else {
			$section.removeClass('js-accordion-fully-open');
			clearTimeout(timeOutId);
		}
	});
